import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useEffect, useMemo, useState } from "react";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db } from "src/firebase/firebase";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required.")
    .typeError("Accept only string"),
  rate: Yup.number()
    .required("Rate is required.")
    .typeError("Accept only number"),

  denominationMin: Yup.number()
    .required("Denomination min price is required.")
    .typeError("Accept only number"),
  denominationMax: Yup.number()
    .required("Denomination max price is required.")
    .typeError("Accept only number")
    .test(
      "is-greater",
      "Denomination max price must be greater than min price",
      function (value) {
        const { denominationMin } = this.parent;
        return value > denominationMin;
      }
    ),
});
const initialValues = {
  name: "",
  rate: 0,
  denominationMin: 0,
  denominationMax: 0,
};
const CreateOffering = ({ setShowRate, priceGroup, cardOffering }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["home"]);
  const [initValue, setInitValue] = useState(initialValues);

  useEffect(() => {
    if (cardOffering) {
      setInitValue(cardOffering);
    }
  }, [cardOffering]);

  const handleAddCard = async (cardValue) => {
    let values: any = {
      ...cardValue,
    };
    if (!cardOffering) {
      values.id = uuidv4();
    }
    values.priceGroup = priceGroup;

    setIsLoading(true);

    await setDoc(doc(db, "Offerings", values.id), values);
    handleToastMessage("success", "Offering added successfully");
    setInitValue({ ...initialValues });
    setShowRate(false);
  };

  return (
    <div className="p-3 pt-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {cardOffering ? t("Edit Offering") : t("Add Offering")}
        </h2>
      </div>
      <div className="pb-4 bg-white">
        <div>
          {Object.keys(initValue).length > 0 && (
            <Formik
              enableReinitialize
              initialValues={initValue}
              validationSchema={validationSchema}
              onSubmit={handleAddCard}
              validateOnBlur
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                handleBlur,
                handleChange,
                isSubmitting,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="flex gap-3 mb-2">
                      <Input
                        label="Offering name"
                        containerClass="w-full"
                        placeholder="Offering name"
                        name="name"
                        className="flex-1"
                        error={errors.name}
                        touched={touched.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        variant="solid"
                      />
                    </div>
                    <div className="flex gap-3 mb-2">
                      <Input
                        containerClass="w-full"
                        placeholder="Denomination min($)"
                        name="denominationMin"
                        className="flex-1"
                        error={errors.denominationMin}
                        touched={touched.denominationMin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.denominationMin}
                        variant="solid"
                      />
                      <Input
                        containerClass="w-full"
                        placeholder="Denomination max($)"
                        name="denominationMax"
                        className="flex-1"
                        error={errors.denominationMax}
                        touched={touched.denominationMax}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.denominationMax}
                        variant="solid"
                      />
                    </div>
                    <Input
                      label="Rate"
                      containerClass="w-full"
                      placeholder="Rate"
                      name="rate"
                      className="flex-1"
                      error={errors.rate}
                      touched={touched.rate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.rate}
                      variant="solid"
                    />

                    <div className="flex justify-end">
                      <Button
                        size="small"
                        className="ml-0 block bg-blue mt-4 mb-3"
                        loading={isLoading}
                        type="button"
                        onClick={handleSubmit as any}
                      >
                        {cardOffering ? t("Update") : t("Add")}
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>
    </div>
  );
};
export default CreateOffering;
